import Service, { getCallApiFunction } from '../service'
import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  queryLiveTime?: Date
  pageSize: number
  pageNo: number
  sortBy?: string
  order?: string
}

class FetchCategoryListApi extends Service {
  constructor(categoryId: number, params: ParamsType) {
    super()
    this.name = 'FETCH_CATEGORY_LIST'

    this.config = {
      url: `/v2/product/category/${categoryId}`, // 後端優化 cache，寫了一版暫時解的 v2，看後端之後會不會再調整改回 v1
      method: 'GET',
      params: { ...params },
    }

    this.denormalizer = denormalizer
  }
}

export const fetchCategoryList = (categoryId: number, params: ParamsType) => getCallApiFunction(new FetchCategoryListApi(categoryId, params))
